import apiRoutes from "startups/apiRoutes";
import { createActionFetcher } from "shared/redux-store/defaults";
import { createActionSubmitter } from "modules/shared/redux-store/defaults";
import { orderCreationSlice } from "./orderCreationSlice";

export const fetchOrderCreation = createActionFetcher("ORDER_CREATION", [
  apiRoutes.orderUnitsOverviewPath(),
  apiRoutes.meProductsPath(),
]);

export const submitDigitalizedOrder = createActionSubmitter(
  "ORDER_CREATION",
  [
    {
      pathFn: apiRoutes.externalOrdersPath,
      verb: "POST",
    },
  ],
  (response, dispatch) => {
    dispatch(orderCreationSlice.actions.orderCreationSuccess());
  },
);
